import ApprovalsComp from '../../Components/Approvals/ApprovalsComp';

function Approvals() {
  return (
    <>
      <ApprovalsComp />
    </>
  );
}

export default Approvals;
